export class BluetoothCompatibilityAction {
    constructor(bluetoothCompatibilityModeActive = null) {
        this.name = 'BluetoothCompatibility';
        this.isDeviceAction = false;
        if (bluetoothCompatibilityModeActive != null) {
            this.data = {
                bluetoothCompatibilityModeActive,
            };
        }
        else {
            this.data = {};
        }
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQmx1ZXRvb3RoQ29tcGF0aWJpbGl0eUFjdGlvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9saWIvbW9kZWxzL2FjdGlvbnMvQmx1ZXRvb3RoQ29tcGF0aWJpbGl0eUFjdGlvbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFLQSxNQUFNLE9BQU8sNEJBQTRCO0lBS3ZDLFlBQVksbUNBQTRDLElBQUk7UUFKNUMsU0FBSSxHQUFHLHdCQUF3QixDQUFDO1FBQ2hDLG1CQUFjLEdBQUcsS0FBSyxDQUFDO1FBSXJDLElBQUksZ0NBQWdDLElBQUksSUFBSSxFQUFFO1lBQzVDLElBQUksQ0FBQyxJQUFJLEdBQUc7Z0JBQ1YsZ0NBQWdDO2FBQ2pDLENBQUM7U0FDSDthQUFNO1lBQ0wsSUFBSSxDQUFDLElBQUksR0FBRyxFQUFFLENBQUM7U0FDaEI7SUFDSCxDQUFDO0NBQ0YifQ==